import React from "react";

import "../../stylesheets/SummarySearch.css";

const VtUserManagementSearch = (props) => {
  return (
    <tr className="search-row">
      <td colSpan="5">
        <input
          required="required"
          className="proview-input"
          id="vt-user-search"
          type="text"
          placeholder="Search users"
          value={props.search}
          onChange={(e) => props.setSearch(e.target.value)}
        />
      </td>
    </tr>
  );
};

export default VtUserManagementSearch;
